
import { resetBotCode, bindBotCode } from '@/api/admin'
import { Form as ElForm } from 'element-ui'
import { secretRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { operationMessage } from '@/utils/message'
import {
  getEnterprise
} from '@/api/universal'
@Component({
  name: 'secret',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) id!: number
  @Prop({ default: true }) isReset!: boolean

  private infoForm: any = {
    google_code: '',
    description: ''
  }
  private rules = secretRules
  private loading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async save () {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        try {
          const data: any = {
            id: this.id,
            ...this.infoForm
          }
          if (this.isReset) {
            await resetBotCode(data).then((res: any) => {
              operationMessage(true)
              this.back()
              this.loading = false
            })
          } else {
            await bindBotCode(data).then((res: any) => {
              operationMessage(true)
              this.loading = false
              this.flagStr()
              this.back()
            })
          }
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private back () {
    this.$emit('close')
  }

  private botGoogle: boolean = false
  private async getEnterprise() {
    try {
      await getEnterprise().then((res: any) => {
        this.botGoogle = res.bot_google_auth_switch
      })
    } catch (e) {
      console.log()
    }
  }

  created () {
    this.getEnterprise()
  }
}
